module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0121.jpg?v=861eedd6";